import './_color/Theme_color_mes_preset.css';
import './_color/Theme_color_dark_preset.css';
import './_control/Theme_control_mes_preset.css';
import './_font/Theme_font_mes_preset.css';
import './_size/Theme_size_mes_preset.css';
import './_space/Theme_space_mes_preset.css';
import './_shadow/Theme_shadow_mes_preset.css';
import './mes-preset.css';
import { presetGpnDark } from '@consta/uikit/Theme';

export const mesPreset = {
    color: {
        primary: 'mes_preset',
        accent: 'mes_preset',
        invert: 'mes_preset'
    },
    control: 'mes_preset',
    font: 'mes_preset',
    size: 'mes_preset',
    space: 'mes_preset',
    shadow: 'mes_preset'
};

export const darkPreset = {
    ...presetGpnDark,
    color: {
        primary: 'dark_preset',
        accent: 'dark_preset',
        invert: 'dark_preset'
    }
};
